import React, { Component } from 'react';
import logo from './logo.svg';
import axios from 'axios';
import { CustomNav } from '../Components/CustomNav';
import {
  Navbar,
  Nav,
  NavItem,
  Grid,
  Row,
  Col,
  Panel,
  Button
} from 'react-bootstrap';
import { RosterTable } from '../Components/RosterTable';
import { Drag2 } from '../Components/Drag';
import { PlayerCard } from '../Components/PlayerCard';
import { ProspectCard } from '../Components/ProspectCard';
import { NonRosteredTable } from '../Components/NonRosteredTable';
import { makeData, Logo, Tips } from '../Utility/utility.js';
import './BigDepthChart.css';
import { teamsData } from '../Pages/dataUrls';
import { AppContext } from '../Pages/App';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions, jwtTeam } from '../_helpers';
export class BigDepthChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playerListHome: [],
      nonRostered: [],
      homeTeam: jwtTeam()
    };
  }

  componentDidMount() {
    if (!this.state.homeTeam) {
      return false;
    }
    //console.log("mount");
    let currentComponent = this;
    axios
      .all([
        axios.get(
          apiServerUrl + '/team_players?team=' + this.state.homeTeam,
          requestOptions()
        )
      ])
      .then(
        axios.spread(homeRes => {
          //console.log(homeRes.data);
          //console.log(awayRes.data);
          if (homeRes.data) {
            currentComponent.setState({
              playerListHome: homeRes.data.players,
              nonRostered: homeRes.data.players.filter(
                x => x.roster_status == 'NON-ROSTER'
              )
            });
          }
        })
      );
  }

  changeTeam(e, side) {
    //this.setState({team: e.target.value});
    if (!e.target.value || e.target.value == undefined) {
      return false;
    }
    console.log(e.target.value);
    let currentComponent = this;
    let value = e.target.value;
    let url = apiServerUrl + '/team_players?team=' + e.target.value;
    // Make a request for a user with a given ID
    axios
      .get(url, requestOptions())
      .then(function(response) {
        currentComponent.setState({
          playerListHome: response.data.players,
          homeTeam: value
        });
      })
      .catch(function(error) {
        //console.log(error);
      });
  }
  toggleActive() {}

  render() {
    return (
      <div>
        <header class="nav">
          <CustomNav />
        </header>
        <div class="team-flex-grid" style={{ marginTop: '1em' }}>
          {/* Left Side */}
          <div
            className="team-hds-container"
            style={{ flexDirection: 'column' }}
          >
            <div
              className="gutter-right"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  flex: 1
                }}
              >
                <div className="hds-container-heading" style={{}}>
                  <span>Your Team</span>
                </div>
                <select
                  class="teamList"
                  style={{ alignSelf: 'flex-start' }}
                  onChange={e => this.changeTeam(e, 'left')}
                >
                  <option>CHOOSE HOME TEAM</option>
                  <AppContext.Consumer>
                    {context =>
                      context.number.map(item => (
                        <option value={item.tricode}>
                          {item.full_team_name}
                        </option>
                      ))
                    }
                  </AppContext.Consumer>
                </select>
              </div>
              {this.state.playerListHome.length > 0 && (
                <RosterTable
                  team={this.state.playerListHome}
                  activeTeam={this.state.homeTeam}
                  toggleActive={this.toggleActive}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BigDepthChart;



// WEBPACK FOOTER //
// ./src/Pages/BigDepthChart.js